import PageHero from '@/components/feature/PageHero';
import { aboutHero } from '@/mocks/about';

export default function AboutHero() {
  return (
    <PageHero
      eyebrow="关于华辉"
      title={aboutHero.name}
      titleHighlight={aboutHero.en}
      subtitle={aboutHero.subtitle}
      desc={aboutHero.desc}
      imageUrl="https://readdy.ai/api/search-image?query=Abstract%20corporate%20technology%20visualization%20with%20deep%20dark%20ink%20navy%20background%2C%20glowing%20blue%20AI%20particles%20and%20digital%20network%20constellation%2C%20eco%20green%20and%20gold%20accent%20light%20streams%2C%20futuristic%20national%20strategy%20and%20artificial%20intelligence%20aesthetic%2C%20minimal%20clean%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1800&height=1100&seq=about-hero-01&orientation=landscape"
      imageAlt="华辉数智技术 公司介绍"
      imageTitle="华辉数智技术 人工智能应用服务"
    />
  );
}